import Vue from 'vue'

export const buyingPowerCalculatorButtonClicked = () => {
  Vue.$clickstream.trackEvent({ event: 'buyingPowerCalculatorButtonClicked' })
}
export const buyingPowerCalculatorHeaderButtonClicked = () => {
  Vue.$clickstream.trackEvent({ event: 'buyingPowerCalculatorHeaderButtonClicked' })
}

